import _Ellipsis from './ellipsis';
import EllipsisItem from './ellipsis-item';
var Ellipsis = Object.assign(_Ellipsis, {
  Item: EllipsisItem
});
export default Ellipsis;
export { Ellipsis };